import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationLT from './locales/lt/translation.json';
import translationEN from './locales/en/translation.json';
import { API_HOST } from './config.js';

const savedLanguage = localStorage.getItem('language') || 'lt';

// Initialize with static fallback translations
i18n.use(initReactI18next).init({
  resources: {
    lt: { translation: translationLT },
    en: { translation: translationEN },
  },
  lng: savedLanguage,
  fallbackLng: 'lt',
  interpolation: { escapeValue: false },
});

// Load dynamic translations from backend and override static ones
const loadDynamicTranslations = async () => {
  try {
    const res = await fetch(`${API_HOST}/api/translations/languages`);
    if (!res.ok) return;
    const langs = await res.json();
    for (const lang of langs) {
      if (!lang.active) continue;
      try {
        const r = await fetch(`${API_HOST}/api/translations/${lang.lang}`);
        if (!r.ok) continue;
        const item = await r.json();
        if (item.data && Object.keys(item.data).length > 0) {
          i18n.addResourceBundle(lang.lang, 'translation', item.data, true, true);
        }
      } catch {}
    }
  } catch {}
};

loadDynamicTranslations();

export default i18n;
export { loadDynamicTranslations };
